import {
  BLOCK_USER,
  BLOCK_USER_ERROR,
  GET_BLOCKED_USERS,
  GET_BLOCKED_USERS_ERROR,
  UNBLOCK_USER,
  UNBLOCK_USER_ERROR,
  CLEAR_BLOCKED_USERS,
} from "../actions/types";

const initialState = {
  blockedusers: [],
  profileblockedusers: [],
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case BLOCK_USER:
    case UNBLOCK_USER:
      return {
        ...state,
        blockedusers: payload,
        loading: false,
      };
    case GET_BLOCKED_USERS:
      return {
        ...state,
        blockedusers: payload.blockedUsers,
        profileblockedusers: payload.blockedProfileUsers,
        loading: false,
      };
    case BLOCK_USER_ERROR:
    case UNBLOCK_USER_ERROR:
    case GET_BLOCKED_USERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_BLOCKED_USERS:
      return {
        ...state,
        blockedusers: [],
        profileblockedusers: [],
        loading: true,
      };
    default:
      return state;
  }
}
